"use client";

import { Pie, PieChart } from "recharts";
import { ChartConfig, ChartContainer, ChartTooltip, cn } from "visuais";

type OnlyPieChartProps = {
  className?: string;
  chartData: any[];
  chartConfig: ChartConfig;
  dataKey: string;
  nameKey: string;
  tooltip?: (payload: any) => {
    title: string | number | undefined;
    sub: string;
    color: string;
  };
};

export function OnlyPieChart({
  className,
  chartData,
  chartConfig,
  dataKey,
  nameKey,
  tooltip,
}: OnlyPieChartProps) {
  // Valor total para o centro
  const total = chartData.reduce((sum, item) => sum + (item[dataKey] ?? 0), 0);

  return (
    <ChartContainer
      config={chartConfig}
      className={cn(className, "mx-auto aspect-square max-h-[250px]")}
    >
      <PieChart>
        <ChartTooltip
          cursor={false}
          content={
            tooltip
              ? ({ active, payload }) => {
                  if (!active || !payload?.length) return null;
                  const tooltipData = tooltip(payload[0].payload);
                  return (
                    <div className="rounded-md bg-card text-foreground p-2 text-xs shadow-lg">
                      <div className="flex flex-col gap-1 min-w-[180px]">
                        <div className="flex items-center gap-1">
                          <span
                            className="w-1 h-4 rounded-full"
                            style={{ backgroundColor: tooltipData.color }}
                          />
                          <span className="font-bold">{tooltipData.title}</span>
                        </div>
                        <div className="flex justify-start text-muted-foreground">
                          <span className="font-medium">{tooltipData.sub}</span>
                        </div>
                      </div>
                    </div>
                  );
                }
              : undefined
          }
        />
        <Pie
          data={chartData}
          dataKey={dataKey}
          nameKey={nameKey}
          innerRadius={45}
          outerRadius={60}
          strokeWidth={5}
        />
      </PieChart>
    </ChartContainer>
  );
}
